export default __webpack_public_path__ + "static/media/chat_bot_image10.b00df5ca.jpg";